import styled from 'styled-components';

const Wrapper = styled.div`
  font-size: 21.5px;
  height: 100%;
`;
Wrapper.displayName = 'Wrapper';

export default Wrapper;
